import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Image, Modal, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import SearchSVG from '../../../assets/images/icons/search.svg';

/*
    - api
*/
import addMemberAPI from '../../../api/post/Member';

const Toolbar = ({ alertProps, nationalCodeSearchProps, reloadUserProps }) => {

    /*
       - default data
    */
    const [addMemberParameters, setAddMemberParameters] = React.useState({
        organizationCode: {
            value: '',
            color: 'dark'
        },
        firstName: {
            value: '',
            color: 'dark'
        },
        lastName: {
            value: '',
            color: 'dark'
        },
        nationalCode: {
            value: '',
            color: 'dark'
        },
        mobileNumber: {
            value: '',
            color: 'dark'
        }
    });
    const [nationalCodeSearchKey, setNationalCodeSearchKey] = React.useState('');

    /*
        - addPassengerHandler
    */
    const addMemberHandler = (key, value) => {
        if (key === 'organizationCode') {
            setAddMemberParameters({
                ...addMemberParameters,
                organizationCode: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'firstName' && value !== '' && /^[آ-ی ]+$/.test(value)) {
            setAddMemberParameters({
                ...addMemberParameters,
                firstName: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'firstName') {
            setAddMemberParameters({
                ...addMemberParameters,
                firstName: {
                    value: value,
                    color: 'danger'
                }
            });
        } else if (key === 'firstName') {
            setAddMemberParameters({
                ...addMemberParameters,
                firstName: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'lastName' && value !== '' && /^[آ-ی ]+$/.test(value)) {
            setAddMemberParameters({
                ...addMemberParameters,
                lastName: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'lastName') {
            setAddMemberParameters({
                ...addMemberParameters,
                lastName: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'nationalCode') {
            if ((value.length === 0 || value.length === 10) && /^[0-9,۰-۹]+$/.test(value)) {
                setAddMemberParameters({
                    ...addMemberParameters,
                    nationalCode: {
                        value: value,
                        color: 'dark'
                    }
                });
            } else {
                setAddMemberParameters({
                    ...addMemberParameters,
                    nationalCode: {
                        value: value,
                        color: 'danger'
                    }
                });
            }
        }
        if (key === 'mobileNumber') {
            if ((value.length === 0 || value.length === 11) && /^[0-9,۰-۹]+$/.test(value)) {
                setAddMemberParameters({
                    ...addMemberParameters,
                    mobileNumber: {
                        value: value,
                        color: 'dark'
                    }
                });
            } else {
                setAddMemberParameters({
                    ...addMemberParameters,
                    mobileNumber: {
                        value: value,
                        color: 'danger'
                    }
                });
            }
        }
    }

    /*
        - addMember
    */
    const addMember = async () => {
        let parameters = {};
        let isValid = 1;
        if (addMemberParameters.firstName.value === '' || !/^[آ-ی ]+$/.test(addMemberParameters.firstName.value)) {
            setAddMemberParameters({
                ...addMemberParameters,
                firstName: {
                    value: addMemberParameters.firstName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addMemberParameters.lastName.value === '' || !/^[آ-ی ]+$/.test(addMemberParameters.lastName.value)) {
            setAddMemberParameters({
                ...addMemberParameters,
                lastName: {
                    value: addMemberParameters.lastName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addMemberParameters.nationalCode.value.length !== 10 || !/^[0-9,۰-۹]+$/.test(addMemberParameters.nationalCode.value)) {
            setAddMemberParameters({
                ...addMemberParameters,
                nationalCode: {
                    value: addMemberParameters.nationalCode.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (addMemberParameters.mobileNumber.value.length !== 11 || !/^[\u06F0-\u06F90-9]+$/.test(addMemberParameters.mobileNumber.value)) {
            setAddMemberParameters({
                ...addMemberParameters,
                mobileNumber: {
                    value: addMemberParameters.mobileNumber.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.OrganizationCode = addMemberParameters.organizationCode.value;
            parameters.FirstName = addMemberParameters.firstName.value;
            parameters.LastName = addMemberParameters.lastName.value;
            parameters.NationalCode = addMemberParameters.nationalCode.value;
            parameters.MobileNumber = addMemberParameters.mobileNumber.value;
            let result = await addMemberAPI(parameters);
            if (result === 'success') {
                setAddMemberParameters({
                    organizationCode: {
                        value: '',
                        color: 'dark'
                    },
                    firstName: {
                        value: '',
                        color: 'dark'
                    },
                    lastName: {
                        value: '',
                        color: 'dark'
                    },
                    nationalCode: {
                        value: '',
                        color: 'dark'
                    },
                    mobileNumber: {
                        value: '',
                        color: 'dark'
                    }
                });
                closeModal('addMemberModal');
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadUserProps(Math.floor(Math.random() * 100));
            } else {
                closeModal('addMemberModal');
                if(result.Message)
                alertProps(['danger', result.Message]);
                else{
                    let arrError = Object.values(result.errors).flat();
                    alertProps(['danger', arrError.join(', ')]);

                }
            }
        }
    }

    /*
        - nationalCodeSearch
    */
    const nationalCodeSearch = () => {
        nationalCodeSearchProps(nationalCodeSearchKey);
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <Typography
                            component='h4'
                            ms={{
                                fontWeight: 'normal !important'
                            }}>
                            مدیریت اعضا
                        </Typography>
                        <Typography
                            className={`d-block`}
                            component='p'
                            ms={{
                                color: '#6F6F7E'
                            }}>
                            می توانید لیست اعضای سازمان خود را در زیر اضافه کنید، تااز خدمات ایران هتل آنلاین بهره‌مند شوند.
                        </Typography>
                    </Grid.Item>
                    <Grid.Item
                        className={`position-relative`}
                        size='col-8 md-4'>
                        <TextField
                            onChange={(value) => setNationalCodeSearchKey(value)}
                            placeholder='جستجو بر اساس کدملی یا پاسپورت'
                            value={nationalCodeSearchKey} />
                        <Button
                            onClick={nationalCodeSearch}
                            variant='light'
                            color='primary'
                            size='sm'
                            ms={{
                                position: 'absolute',
                                top: '12px',
                                left: '12px',
                            }}>
                            <Image
                                src={SearchSVG} />
                        </Button>
                    </Grid.Item>
                    <Grid.Item
                        className={`text-left`}
                        size='col-4 md-8'>
                        {(scale === 'xx-large' || scale === 'x-large' || scale === 'large' || scale === 'medium' || scale === 'small') &&
                            <Button
                                onClick={() => openModal('addMemberModal')}
                                color='primary'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                افزودن عضو جدید
                            </Button>
                        }
                        {(scale === 'x-small' || scale === 'x-small') &&
                            <Button
                                onClick={() => openModal('addMemberModal')}
                                color='primary'
                                ms={{
                                    '@media(max-width:576px)': {
                                        width: '100% !important'
                                    }
                                }}>
                                عضو جدید
                            </Button>
                        }
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
            <Modal
                className={`addMemberModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: 'calc(100% - 12px) !important'
                        }
                    }}>
                    <Modal.Header
                        className={`border-solid-bottom border-light`}>
                        افزودن عضو جدید
                        <Box />
                    </Modal.Header>
                    <Box
                        className={`my-md mt-0`} />
                    <Typography
                        className={`px-lg`}>
                        اطلاعات اعضای خود را وارد نمایید.
                    </Typography>
                    <Box
                        className={`p-sm`}
                        component='form'>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item
                                    size='col-12 '>
                                    <TextField
                                        onChange={(value) => addMemberHandler('organizationCode', value)}
                                        label='کد سازمانی'
                                        color={addMemberParameters.organizationCode.color}
                                        value={addMemberParameters.organizationCode.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addMemberHandler('firstName', value)}
                                        label='نام'
                                        color={addMemberParameters.firstName.color}
                                        value={addMemberParameters.firstName.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addMemberHandler('lastName', value)}
                                                label='نام خانوادگی'
                                        color={addMemberParameters.lastName.color}
                                        value={addMemberParameters.lastName.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addMemberHandler('nationalCode', value)}
                                        label='کد ملی'
                                        color={addMemberParameters.nationalCode.color}
                                        value={addMemberParameters.nationalCode.value} />
                                </Grid.Item>
                                <Grid.Item
                                    size='col-12 md-6'>
                                    <TextField
                                        onChange={(value) => addMemberHandler('mobileNumber', value)}
                                        label='شماره همراه'
                                        placeholder='091xxxxxxxxx'
                                        color={addMemberParameters.mobileNumber.color}
                                        value={addMemberParameters.mobileNumber.value} />
                                </Grid.Item>
                                <Grid.Item
                                    className={`d-flex pb-0`}
                                    size='col-12 md-6'>
                                    <Button
                                        onClick={addMember}
                                        className={`w-25`}
                                        variant='filled'
                                        color='primary'>
                                        تایید
                                    </Button>
                                    <Box
                                        className={`mx-sm`} />
                                    <Button
                                        onClick={() => closeModal('addMemberModal')}
                                        className={`w-25`}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );

}

export default Toolbar;